<div class="body-container body-container--light">
  <div class="header-container">
    <app-header-light></app-header-light>
  </div>
  <div class="content-container">
    <router-outlet></router-outlet>
  </div>
  <app-live-agent></app-live-agent>
</div>
